import tmhRequest from '@/config/tmhRequest'

export default {
  searchStore: function ( data) {
    return tmhRequest({
      url: '/store/tmh/store/searchstore',
      method: 'post',
      params: data,
    })
  },
  searchListStore: function ( data) {
    return tmhRequest({
      url: '/store/tmh/store/searchliststore',
      method: 'post',
      params: data,
    })
  },
  searchStoreCount: function ( data) {
    return tmhRequest({
      url: '/store/tmh/store/searchstorecount',
      method: 'post',
      data: data,
    })
  },
  searchStoreByPage: function ( data) {
    return tmhRequest({
      url: '/store/tmh/store/searchstorebypage',
      method: 'post',
      data: data,
    })
  },
  editStore: function ( data) {
    return tmhRequest({
      url: '/store/tmh/store/editstore',
      method: 'post',
      params: data,
    })
  },

}


// WEBPACK FOOTER //
// ./src/api/tmh/store/store.js